/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import './WebsitePartnersPage.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import ConfirmModal from '../../common/confirm-modal/ConfirmModal';
import LoadingModal from '../../common/loading-modal/LoadingModal';
import { confirmModalTypesValues } from '../../const-values/confirmModalTypes';
import { LoadingOutlined } from '@ant-design/icons';
import {
  setDeleteModalOpened,
  setSelectedTableRow
} from '../../redux/website-partners-slice/websitePartnersSlice';
import CustomEmpty from '../../common/custom-empty/CustomEmpty';
import EditIcon from '../../common/icons/EditIcon';
import getFoundObjByValue from '../../helpers/getFoundObjByValue';
import {
  brandsStatus,
  getBrandsStatusArr
} from '../../const-values/brandsStatus';
import { Tag } from 'antd';
import CustomImage from '../../common/custom-image/CustomImage';
import TrashIcon from '../../common/icons/TrashIcon';
import TitleDescForm from '../../components/title-desc-form/TitleDescForm';
import { getSingleSectionTitlesAction } from '../../redux/section-titles-slice/SectionTitlesSliceThunkApi';
import { setFetchedSingleTitle } from '../../redux/section-titles-slice/SectionTitlesSlice';
import {
  deleteWebsitePartnerAction,
  getWebsitePartnersAction
} from '../../redux/website-partners-slice/websitePartnersSliceThunkApi';
import WebsitePartnerForm from './WebsitePartnerForm';

const WebsitePartnersPage = () => {
  const dispatch = useDispatch();
  const deleteModalOpened = useSelector(
    (store) => store.websitePartners.deleteModalOpened
  );
  const isLoadingTableData = useSelector(
    (store) => store.websitePartners.isLoadingTableData
  );
  const selectedTableRow = useSelector(
    (store) => store.websitePartners.selectedTableRow
  );
  const fetchDataCount = useSelector(
    (store) => store.websitePartners.fetchDataCount
  );
  const isSubmitting = useSelector(
    (store) => store.websitePartners.isSubmitting
  );
  const fetchedTableData = useSelector(
    (store) => store.websitePartners.fetchedTableData
  );
  const fetchSingleTitleCount = useSelector(
    (store) => store.sectionTitles.fetchSingleCount
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let isMounted = true;

  useEffect(() => {
    if (isMounted) {
      dispatch(
        getSingleSectionTitlesAction({
          filterObj: {
            id: 3
          }
        })
      );
    }

    return () => dispatch(setFetchedSingleTitle(null));
  }, [fetchSingleTitleCount]);

  useEffect(() => {
    if (isMounted)
      dispatch(
        getWebsitePartnersAction({
          filterObj: null
        })
      );

    return function () {
      isMounted = false;
    };
  }, [fetchDataCount]);

  const handleDeleteObj = () => {
    if (isMounted && selectedTableRow?.id) {
      const formData = new FormData();
      formData.append('partner_id', selectedTableRow.id);
      dispatch(
        deleteWebsitePartnerAction({
          dataToBeSubmitted: formData
        })
      );
    }
  };

  const CardItem = (card) => {
    
    return (
      <div className="item-item">
        <CustomImage src={card?.image} className="item-img-wrapper" />
        <div className="item-content">
          <div
            className="item-details"
            style={{
              display: 'flex',
              gap: 4,
              alignItems: 'center'
            }}
          >
            <p className="name">{card?.name_ar}</p>
          </div>
          <div className="item-btns-wrapper">
            <button
              onClick={() => {
                dispatch(setSelectedTableRow(card));
                dispatch(setDeleteModalOpened(true));
              }}
              style={{
                padding: 0
              }}
              className="btn delete-btn"
            >
              <TrashIcon color="rgba(64, 64, 65, 0.6)" />
              حذف
            </button>
            <button
              style={{
                padding: 0
              }}
              className="btn edit-btn"
              onClick={() => {
                dispatch(setSelectedTableRow(card));
              }}
            >
              <EditIcon color="rgba(64, 64, 65, 0.6)" />
              تعديل
            </button>

            {getFoundObjByValue(getBrandsStatusArr(), card?.status) && (
              <Tag
                color={card?.status === brandsStatus?.active ? 'green' : 'red'}
              >
                {getFoundObjByValue(getBrandsStatusArr(), card?.status).name}
              </Tag>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderList = useMemo(() => {
    return () => {
      if (isLoadingTableData) {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 360
            }}
          >
            <LoadingOutlined />
          </div>
        );
      } else if (fetchedTableData?.length === 0) {
        return (
          <CustomEmpty
            style={{
              minHeight: 642
            }}
          >
            <h3
              style={{
                color: '#40404166',
                marginTop: 18
              }}
            >
              لم تقم بإضافة شركاء بعد
            </h3>
          </CustomEmpty>
        );
      } else if (fetchedTableData?.length > 0) {
        return (
          <div className="sec-list-wrapper">
            {fetchedTableData.map((item) => {
              return <CardItem key={item.id} {...item} />;
            })}
          </div>
        );
      }
      return null;
    };
  }, [fetchedTableData, isLoadingTableData]);

  return (
    <div className="website-page website-partners-page">
      <p className="website-title">الموقع الالكترونى</p>
      <p className="page-title">شركاؤنا</p>
      <div className="form-list-wrapper">
        <div className="forms-section">
          <TitleDescForm />
          <WebsitePartnerForm fetchedTableData={fetchedTableData} />
        </div>

        <div className="desc-sec">
          <div className="desc-header">الشركاء</div>
          {renderList()}
        </div>
      </div>

      {/* delete modal */}
      <ConfirmModal
        modalTitle=""
        modalOpened={deleteModalOpened}
        modalType={confirmModalTypesValues?.errorModal}
        setModalOpened={(v) => dispatch(setDeleteModalOpened(v))}
        handleAccept={handleDeleteObj}
      >
        <h3>{`هل انت متأكد من الحذف ${selectedTableRow?.name || ''}`}</h3>
      </ConfirmModal>
      {/* end delete modal */}

      {(isSubmitting || isLoadingTableData) && <LoadingModal />}
    </div>
  );
};

export default WebsitePartnersPage;
